import React, { Component } from 'react';

import { Navbar, Nav, Dropdown, DropdownButton } from 'react-bootstrap';

import logo from '../../../img/logo.png'

import './template.css'

import i18n from '../../i18n';

export default class Header extends Component {

	constructor(props) {
		super(props);
		this.handleLanguageChange = this.handleLanguageChange.bind(this);
	}

	componentDidMount() {

		window.onscroll = function () { scrollFunction() };
		function scrollFunction() {
			if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
				document.getElementsByClassName("navbar")[0].style.setProperty("padding-top", "10px", "important");
				document.getElementsByClassName("navbar")[0].style.setProperty("padding-bottom", "10px", "important");
				//document.getElementsByClassName("logo").style.fontSize = "25px";
			} else {
				document.getElementsByClassName("navbar")[0].style.setProperty("padding-top", "20px", "important");
				document.getElementsByClassName("navbar")[0].style.setProperty("padding-bottom", "20px", "important");
				//document.getElementBygetElementsByClassNameId("logo").style.fontSize = "35px";
			}
		}
	}

	handleLanguageChange(lang) {
		i18n.changeLanguage(lang);
		window.location.reload();
	}

	render() {
		var defaultLang = i18n.languages[0].toUpperCase();
		return (
			<Navbar variant="dark" className="fixed-top" expand="lg" collapseOnSelect={true}>
				<Navbar.Brand href={document.getElementById("endpoint").getAttribute("value") + "#validate"}><img
					src={logo}
					width="125"
					height="30"
					className="d-none d-sm-inline-block align-top"
					alt="Fina logo"
				/>
					<span>{i18n.t("header:naslov")}</span>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
					<Nav className="">
						<Nav.Link data-scroll href={document.getElementById("endpoint").getAttribute("value") + "#about"} >{i18n.t("header:o_nama")}</Nav.Link>
						<Nav.Link data-scroll href={document.getElementById("endpoint").getAttribute("value") + "#guide"} >{i18n.t("header:guide")}</Nav.Link>
						<Nav.Link data-scroll href={document.getElementById("endpoint").getAttribute("value") + "#faq"} >{i18n.t("header:faq")}</Nav.Link>
						<DropdownButton id="dropdown-info-button" title={<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>}>
							<Dropdown.Item data-scroll href={document.getElementById("endpoint").getAttribute("value") + "/termsOfService"} >{i18n.t("header:tos")}</Dropdown.Item>
							<Dropdown.Item data-scroll href={document.getElementById("endpoint").getAttribute("value") + "/cookiesPolicy"} >{i18n.t("header:cookies_policy")}</Dropdown.Item>
							<Dropdown.Item data-scroll href={document.getElementById("endpoint").getAttribute("value") + "/privacyPolicy"} >{i18n.t("header:privacy_policy")}</Dropdown.Item>
						</DropdownButton>
						{document.getElementById("language") == null ?
							<DropdownButton id="dropdown-language-button" title={i18n.t("header:lang") + defaultLang}>
								<Dropdown.Item onClick={() => this.handleLanguageChange("en")}>EN</Dropdown.Item>
								<Dropdown.Item onClick={() => this.handleLanguageChange("hr")}>HR</Dropdown.Item>
							</DropdownButton>
							:
							null
						}
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		)
	}
}